import { render, staticRenderFns } from "./AlertText.vue?vue&type=template&id=22107aa0&scoped=true"
import script from "./AlertText.vue?vue&type=script&lang=js"
export * from "./AlertText.vue?vue&type=script&lang=js"
import style0 from "./AlertText.vue?vue&type=style&index=0&id=22107aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22107aa0",
  null
  
)

export default component.exports